<template>
  <div class="sb_main-footer">
    <div class="sb_main-footer_line u_max-width-1200"></div>

    <div class="sb_main-footer_content u_max-width-1200">
      <div class="sb_main-footer_menu-primary">
        <div class="sb_main-footer_menu-primary_text">
          <b>Disclaimer:</b>

          This calculator is provided to you free of charge and 'as-is' and Corbion makes no representations or warranties with respect to the use, effectiveness or functionality of the calculator. It is meant as a helpful tool to aid you calculate the water activity of a formulation, but should not replace regular testing of formulations and substances. Corbion's regular <a
            target="_blank"
            href="https://www.corbion.com/about-corbion/disclaimer"
          >disclaimer</a> applies.
        </div>
        <!-- <a
          href="https://clcm.corbion.com/disclaimer.html"
          target="_blank"
          class="sb_main-footer_menu-primary_link"
        >Disclaimer</a> -->
        <!-- <a
          href="http://www.corbion.com/food/contact-us/request-a-sample-for-your-meat-formulations"
          target="_blank"
          class="sb_main-footer_menu-primary_link"
        >Sample request</a>
        <a
          class="sb_main-footer_menu-primary_link"
          @click="openKeepMeUpdatedModal"
        >Keep me updated</a>
        <a
          class="sb_main-footer_menu-primary_link"
          @click="openInformColleagueModal"
        >Share this tool</a>
      </div> -->
      </div>

      <div
        class="sb_main-footer_menu-primary_version"
      >
        v{{ version }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MainFooter',
  components: {},
  data() {
    return {
      showInformColleagueModal: false,
      showKeepMeUpdatedModal: false,
      version: process.env.VUE_APP_VERSION
    };
  },
  methods: {
    openInformColleagueModal() {
      this.showInformColleagueModal = true;
    },
    openKeepMeUpdatedModal() {
      this.showKeepMeUpdatedModal = true;
    }
  }
};
</script>

<style lang="scss">
  .sb_main-footer {
    width: 100%;

    &_content {
      margin: 0 auto;
      padding: 0 2rem;

    }
    &_menu-primary {
      @include media(">=medium-portrait") {
        display: flex;
        justify-content: center;
      }

      &_text {
        font-size: 0.8rem;
        max-width: 820px;

        line-height: 1.5;
        color: rgba($brand-primary, .4);
        a {
          color: $brand-primary;
          &:hover {
            color: $brand-secondary;
            cursor: pointer;
          }
        }
      }

      &_version {
        font-size: 0.8rem;
        color: rgba($brand-primary, .4);
        padding: 1rem 1rem 1rem 0;

        @include media(">=large") {
          padding: 0;
          position: absolute;
          bottom: 50%;
          transform: translateY(50%);
          right: 1rem;
        }
      }


      &_link {
        text-decoration: none;
        margin: 0 .5rem;
        font-size: .9rem;
        @include media("<medium-portrait") {
          margin: 0;
          display: block;
          text-align: center;
          width: 100%;
          font-size: 1rem;
          padding: .4rem 0;
        }

        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  //
  // BRAND STYLING
  //

  @include sb_main-footer;

</style>
